import React from 'react';
export function SectionDivider() {
  return <div className="flex justify-center items-center gap-2 my-12 opacity-30" data-id="element-8">
      <div className="w-1.5 h-1.5 rounded-full bg-gray-900" data-id="element-9" />
      <div className="w-1.5 h-1.5 rounded-full bg-gray-900" data-id="element-10" />
      <div className="w-1.5 h-1.5 rounded-full bg-gray-900" data-id="element-11" />
    </div>;
}